var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromocode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1481_5878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.546 15.44L16.546 3.44002C16.066 2.96002 15.3994 2.66669 14.666 2.66669H5.33268C3.86602 2.66669 2.66602 3.86669 2.66602 5.33335V14.6667C2.66602 15.4 2.95935 16.0667 3.45268 16.56L15.4527 28.56C15.9327 29.04 16.5994 29.3334 17.3327 29.3334C18.066 29.3334 18.7327 29.04 19.2127 28.5467L28.546 19.2134C29.0394 18.7334 29.3327 18.0667 29.3327 17.3334C29.3327 16.6 29.026 15.92 28.546 15.44ZM17.3327 26.68L5.33268 14.6667V5.33335H14.666V5.32002L26.666 17.32L17.3327 26.68Z",
    fill: "#006187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 10.6667C9.77059 10.6667 10.666 9.77126 10.666 8.66669C10.666 7.56212 9.77059 6.66669 8.66602 6.66669C7.56145 6.66669 6.66602 7.56212 6.66602 8.66669C6.66602 9.77126 7.56145 10.6667 8.66602 10.6667Z",
    fill: "#006187"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1481_5878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromocode);
export default __webpack_public_path__ + "static/media/promocode.11096d833a4b48160006f6668349995d.svg";
export { ForwardRef as ReactComponent };